<p-sidebar
  (onHide)="closePopup()"
  [fullScreen]="fullScreen"
  [modal]="true"
  [(visible)]="isOpen"
  [position]="position"
  [style]="{ width }"
  [showCloseIcon]="true"
  [baseZIndex]="10000"
>
  <ng-template pTemplate="header">
    <div class="custom-header">
      <h3>{{ headerTitle |  textLimiter:150 }}</h3>
    </div>
  </ng-template>

  <div class="custom-content">
    <ng-content></ng-content>
  </div>

  <ng-template pTemplate="footer" *ngIf="showFooter">
    <div class="custom-footer">
      <button type="button" class="btn btn-danger" (click)="closePopup()">
        {{ "common.cancel" | translate }}
      </button>
      <button
        *ngIf="showSaveButton"
        type="button"
        [disabled]="saveButtonDisable"
        class="btn btn-success"
        (click)="save()"
      >
        {{ saveText }}
      </button>
      <button
        *ngIf="showThirdButton"
        type="button"
        class="btn btn-success"
        (click)="onPressThirdButton()"
      >
        {{ thirdButtonText }}
      </button>
    </div>
  </ng-template>
</p-sidebar>
